import { Col, Row } from "react-bootstrap";
import Physician from "../../../Physician/Models/Physician";
import React, { Fragment } from "react";
import { MedicalLicense } from "../../../Physician/Models/MedicalLicense";


interface IProps{
    physician: Physician;
    showNotMeeting: boolean;
}

export default function CCBlockSummaryMedicalLicenseCard(props: IProps) {
    const nbsp = '\u00A0';
    const hasValidLicense = (medicalLicenses: MedicalLicense[]) => {
        let expirationDates: Array<Date> = [];
        medicalLicenses.forEach((license: MedicalLicense) => {
            var date = new Date(license.expirationDate);
            expirationDates.push(date);
        })
        const todaysDate = new Date;
        return expirationDates.some((e) => e > todaysDate)
    }

    return (
        <Fragment>
            <div className="ccenrollment-summary-padding">
                <div className="ccenrollment-summary-border" style={{background: '#fff'}}>
                    <Row className="ccenrollment-summary-cert">
                        <Col>
                            <Row className="ccenrollment-certificate-header">
                                <Col>
                                    <div className="mb-0 font-weight-bolder card-title pp-font-size-small text-center">Medical Licensure</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {hasValidLicense(props.physician.medicalLicenses) == true ? 
                                <>
                                    <Row>
                                        <Col className="text-center">
                                            <div className="text-success">
                                                <div className="las la-check-circle la-3x">
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="text-center text-success pp-font-size-small">
                                                Medical License is current
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                                :
                                <>
                                    <Row>
                                        <Col className="text-center">
                                            <div className="text-danger">
                                                <div className="las la-times-circle la-3x">
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div className="text-center text-danger pp-font-size-small">
                                                Update Medical License
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-larger">
                                {nbsp}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-larger">
                                {nbsp}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-larger">
                                {nbsp}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="pp-font-size-larger">
                                {nbsp}
                            </div>
                        </Col>
                    </Row>
                    { props.showNotMeeting &&
                        <> 
                            <Row>
                                <Col>
                                    <div className="pp-font-size-largest">
                                        {nbsp}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="pp-font-size-small">
                                        {nbsp}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="pp-font-size-smaller">
                                        {nbsp}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="pp-font-size-smallest">
                                        {nbsp}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="pp-font-size-smallest">
                                        {nbsp}
                                    </div>
                                </Col>
                            </Row>
                        </>
                    }
                </div>
            </div>
        </Fragment>
    );
}